import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from "react-router-dom";
import TestList from "./TestList";
import TestDetails from "./TestDetails";
import TestForGrade from "./TestForGrade";


function mapStateToProps(state) {
  return {};
}

class TestsIndex extends Component {
  render() {
    return (
      <Switch>
        <Route component={TestForGrade} path="/tests/for-grade"/>
        <Route component={TestList} path="/tests/index"/>
        <Route component={TestDetails} path="/tests/:guid"/>
      </Switch>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
)(TestsIndex));
